module.exports = {

    doublegame: {

        CARDS_NUMBER: 5,
        X_START_CARDS: 170,
        Y_CARDS: 292,
        X_START_OFFSET: 0,
        X_OFFSET: 167,

        FLIP_TIME: 250,

        background: {
            position: {x: 0, y: 0},
            image: "res/sea_backgrounds/sea_background_0.jpg"
        },

        currentWinLabel: {
            position: {x: 250, y: 50},
            font: "gamble_amount_font",
            align: "center"
        },

        nextWinLabel: {
            position: {x: 740, y: 50},
            font: "gamble_to_win_font",
            align: "center"
        },

        pick: {
            image: "double_pick.png",
            y_position: 292+228
        },

        shirt: "shirt.png",
    }
};


//////////////////
// WEBPACK FOOTER
// ./cfg/doublegame-config.js
// module id = 26
// module chunks = 0